// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.analytics.enums.CustomerAnalyticsListingFilterType

export enum CustomerAnalyticsListingFilterType {
  ALL = 'ALL',
  PAID = 'PAID',
  /**
   * @deprecated
   */
  TIER2 = 'TIER2',
  TIER2_OVER_25 = 'TIER2_OVER_25',
  TIER2_UNDER_25 = 'TIER2_UNDER_25',
  TIER3 = 'TIER3',
}

export const CustomerAnalyticsListingFilterType_values = [
  CustomerAnalyticsListingFilterType.ALL,
  CustomerAnalyticsListingFilterType.PAID,
  CustomerAnalyticsListingFilterType.TIER2,
  CustomerAnalyticsListingFilterType.TIER2_OVER_25,
  CustomerAnalyticsListingFilterType.TIER2_UNDER_25,
  CustomerAnalyticsListingFilterType.TIER3,
] as const;
